import React from 'react';

function CircleChevronDown() {
  return (
    <svg width="16" height="15" aria-hidden="true" focusable="false" role="img" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.75C10.4883 0.75 12.7852 2.08984 14.043 4.25C15.3008 6.4375 15.3008 9.08984 14.043 11.25C12.7852 13.4375 10.4883 14.75 8 14.75C5.48438 14.75 3.1875 13.4375 1.92969 11.25C0.671875 9.08984 0.671875 6.4375 1.92969 4.25C3.1875 2.08984 5.48438 0.75 8 0.75ZM4.69141 7.33984L7.53516 10.1836C7.78125 10.457 8.19141 10.457 8.46484 10.1836L11.2812 7.33984C11.5547 7.09375 11.5547 6.68359 11.2812 6.4375C11.0352 6.16406 10.625 6.16406 10.3516 6.4375L7.97266 8.81641L5.59375 6.4375C5.34766 6.16406 4.9375 6.16406 4.69141 6.4375C4.41797 6.68359 4.41797 7.09375 4.69141 7.33984Z" />
    </svg>
  );
}

export { CircleChevronDown };
